module.exports = __webpack_public_path__ + "921a94994be4ed2290980fa69a41094a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/spirulina.jpg
 ** module id = 456
 ** module chunks = 0
 **/